export const SEND_METER = "SEND_METER";
export const SEND_METER_SUCCESS = "SEND_METER_SUCCESS";
export const SEND_METER_FAIL = "SEND_METER_FAIL";
export const RESET_COMMAND_SUCCESS_GET = "RESET_COMMAND_SUCCESS_GET";
export const SET_ACTIVE_METER_SPARE_PART = "SET_ACTIVE_METER_SPARE_PART";
